import {TableOptions} from "./Table";

export const detailTableOptions: Pick<TableOptions<{}>, "search" | "filtering" | "sorting" | "paging" | "toolbar"> = {
    search: false,
    filtering: false,
    sorting: false,
    paging: false,
    toolbar: false
};